import {
  SET_RO_LEADS_PENDING,
  SET_RO_LEADS_FULFILLED,
  SET_RO_LEADS_FAILED,
  RESET_SET_RO_LEADS,
  SET_IS_RO_CUSTOMER,
  SET_STEP3_BUTTON_CLICKED,
  SET_IS_LANDED_EVENT,
} from "constants-lib/actionTypes"
import { API_STATUSES } from "constants-lib/common"

const initialState = {
  setROLeadsStatus: ``,
  roLeadsStatus: {},
  isFromROFlow: false,
  isCheckAvailabilityButtonClicked: false,
  isLandedEventLoaded: false,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_RO_LEADS_PENDING:
      return {
        ...state,
        setROLeadsStatus: API_STATUSES.PENDING,
        roLeadsStatus: {},
      }

    case SET_RO_LEADS_FULFILLED:
      return {
        ...state,
        setROLeadsStatus: API_STATUSES.FULFILLED,
        roLeadsStatus: action.payload,
      }

    case SET_RO_LEADS_FAILED:
      return {
        ...state,
        setROLeadsStatus: API_STATUSES.FAILED,
        roLeadsStatus: {},
      }

    case SET_IS_RO_CUSTOMER:
      return {
        ...state,
        isFromROFlow: action.payload,
      }

    case SET_STEP3_BUTTON_CLICKED:
      return {
        ...state,
        isCheckAvailabilityButtonClicked: action.payload,
      }
    case SET_IS_LANDED_EVENT:
      return {
        ...state,
        isLandedEventLoaded: action.payload,
      }

    case RESET_SET_RO_LEADS:
      return {
        ...initialState,
      }

    default:
      return state
  }
}
